(() => {
  if (window.kkStorefrontNumbersReady) return;
  window.kkStorefrontNumbersReady = true;
  const roots = new Map();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const easing = 'cubic-bezier(.25,.1,.2,1)';
  const reelEasings = ['cubic-bezier(.14,.72,.2,1)', 'cubic-bezier(.18,.67,.22,1)', 'cubic-bezier(.12,.75,.18,1)'];
  const fallback = {
    regionName: 'Deutschland',
    examRegion: 'Mittelwert der bestätigten Termine',
    target: '2026-12-06T08:00:00+01:00',
    dateLabel: '6. Dezember 2026',
    exact: false
  };

  function initialize(root) {
    if (roots.has(root)) return;
    const handlers = new AbortController();
    const toggle = root.querySelector('[data-kk-background-motion]');
    const examRoot = root.querySelector('#pruefung');
    const examViewportTarget = examRoot?.querySelector('.kk-exam__time');
    const scrollContainer = root.closest('.page-wrapper');
    const counters = new Map();
    const animations = new Map();
    const reels = new Map();
    let observer;
    let timer;
    let destroyed = false;
    let pageHidden = false;
    let manuallyPaused = false;
    let examVisible = !('IntersectionObserver' in window);
    let scrollEligible = false;
    let introPlayed = false;
    let introRunning = false;
    let exam = fallback;
    try { manuallyPaused = localStorage.getItem('kk-background-motion') === 'off'; } catch {}
    const motionAllowed = () => !preference.matches && !manuallyPaused && !document.hidden && !pageHidden;
    const span = (className, text) => {
      const element = document.createElement('span');
      element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };

    function makeDigit(prefix, character) {
      const element = span(`${prefix}__digit`);
      const current = span(`${prefix}__current`, character);
      element.append(current);
      return { element, current, value: character, previous: null };
    }

    function makeReel(digit, prefix, final, duration, seed, initial) {
      const strip = span(`${prefix}__reel`);
      const steps = (2 + seed % 3) * 10 + Number(final);
      strip.append(span(`${prefix}__reel-step`, initial));
      for (let step = 1; step <= steps; step++) strip.append(span(`${prefix}__reel-step`, String(step % 10)));
      digit.element.append(strip);
      digit.element.classList.add('is-rolling');
      const animation = strip.animate([
        { transform: 'translateY(0)' },
        { transform: `translateY(-${steps / (steps + 1) * 100}%)` }
      ], { duration, easing: reelEasings[seed % reelEasings.length], fill: 'both' });
      return { animation, strip };
    }

    root.querySelectorAll('.kk-learning__facts strong[data-kk-count]').forEach((element, order) => {
      const target = Number(element.dataset.kkCount);
      if (!Number.isSafeInteger(target) || target < 0) return;
      const text = element.textContent.trim();
      const canonical = span('kk-number__canonical', text);
      const visual = span('kk-number__visual', '0');
      visual.setAttribute('aria-hidden', 'true');
      element.replaceChildren(canonical, visual);
      element.classList.add('kk-number');
      counters.set(element, { element, visual, target, text, order, reels: new Map(), delay: undefined, running: false, done: false, visible: !('IntersectionObserver' in window) });
    });

    function finishCounter(counter) {
      counter.running = false;
      clearTimeout(counter.delay);
      counter.delay = undefined;
      counter.reels.forEach(({ animation, strip }, digit) => {
        animation.cancel();
        strip.remove();
        digit.element.classList.remove('is-rolling');
      });
      counter.reels.clear();
      if (counter.visual.children.length || counter.visual.textContent !== counter.text) counter.visual.textContent = counter.text;
      counter.done = true;
      counter.element.classList.remove('is-counting');
      observer?.unobserve(counter.element);
    }

    function startCounter(counter) {
      if (counter.done || counter.running || !counter.visible || !motionAllowed()) return;
      counter.running = true;
      counter.delay = setTimeout(() => {
        counter.delay = undefined;
        if (destroyed || !counter.visible || !motionAllowed()) return finishCounter(counter);
        if (typeof counter.visual.animate !== 'function') return finishCounter(counter);
        counter.element.classList.add('is-counting');
        const digits = [];
        counter.visual.replaceChildren(...Array.from(counter.text, character => {
          if (!/\d/.test(character)) return span('kk-number__separator', character);
          const digit = makeDigit('kk-number', character);
          digits.push(digit);
          return digit.element;
        }));
        digits.forEach((digit, index) => {
          const reel = makeReel(digit, 'kk-number', digit.value, 2000 + counter.order * 380 + index * 210, counter.order + index, '0');
          counter.reels.set(digit, reel);
          reel.animation.onfinish = () => {
            if (!counter.running || !counter.reels.has(digit)) return;
            reel.animation.cancel();
            reel.strip.remove();
            counter.reels.delete(digit);
            digit.element.classList.remove('is-rolling');
            if (!counter.reels.size) finishCounter(counter);
          };
        });
      }, 500);
    }

    const fields = examRoot ? ['days', 'hours', 'minutes', 'seconds'].map(name => {
      const element = examRoot.querySelector(`[data-kk-${name}]`);
      if (!element) return null;
      const canonical = span('kk-countdown__canonical', element.textContent);
      const visual = span('kk-countdown__visual');
      const placeholder = span('kk-countdown__placeholder', '--');
      visual.setAttribute('aria-hidden', 'true');
      placeholder.setAttribute('aria-hidden', 'true');
      element.classList.add('kk-countdown');
      element.replaceChildren(canonical, visual, placeholder);
      return { name, element, canonical, visual, digits: [], value: '' };
    }).filter(Boolean) : [];

    function settleDigit(digit) {
      const running = animations.get(digit);
      if (!running) return;
      running.forEach(animation => animation.cancel());
      animations.delete(digit);
      digit.previous?.remove();
      digit.previous = null;
    }

    function drawField(field, value, animate) {
      if (field.value === value) return;
      field.canonical.textContent = value;
      if (field.digits.length !== value.length) {
        field.digits.forEach(settleDigit);
        field.digits = Array.from(value, character => makeDigit('kk-countdown', character));
        field.visual.replaceChildren(...field.digits.map(digit => digit.element));
      } else field.digits.forEach((digit, index) => {
        const character = value[index];
        const strip = reels.get(digit)?.strip;
        if (strip) {
          strip.lastChild.textContent = character;
          return;
        }
        if (digit.value === character) return;
        settleDigit(digit);
        const previousValue = digit.value;
        digit.current.textContent = character;
        digit.value = character;
        if (introRunning || !animate || !digit.current.animate) return;
        digit.previous = span('kk-countdown__previous', previousValue);
        digit.element.append(digit.previous);
        const options = { duration: 440, easing };
        const incoming = digit.current.animate([{ transform: 'translateY(70%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], options);
        const outgoing = digit.previous.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-70%)', opacity: 0 }], options);
        animations.set(digit, [incoming, outgoing]);
        outgoing.onfinish = () => settleDigit(digit);
      });
      field.value = value;
    }

    function drawExam(animate = false) {
      if (!examRoot) return false;
      const remaining = Math.max(0, Math.ceil((Date.parse(exam.target) - Date.now()) / 1000));
      if (!remaining && introRunning) finishIntro();
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      if (introRunning && fields.some(field => field.digits.length !== String(values[field.name]).padStart(2, '0').length)) finishIntro();
      fields.forEach(field => {
        field.element.classList.toggle('is-pending', remaining > 0 && !introPlayed && !preference.matches && !manuallyPaused);
        drawField(field, String(values[field.name]).padStart(2, '0'), animate && introPlayed && scrollEligible && remaining > 0 && motionAllowed() && examVisible);
      });
      const title = examRoot.querySelector('#kk-exam-title');
      const titleText = remaining ? 'Dein Ziel rückt näher.' : 'Der Prüfungstermin ist da.';
      if (title.textContent !== titleText) title.textContent = titleText;
      return remaining > 0;
    }

    function finishIntro() {
      if (!introRunning) return;
      introRunning = false;
      reels.forEach(({ animation, strip }, digit) => {
        animation.cancel();
        strip.remove();
        digit.element.classList.remove('is-rolling');
      });
      reels.clear();
      examRoot.dataset.kkReelIntro = 'done';
      fields.forEach(field => { field.value = ''; });
      drawExam();
    }

    function startIntro() {
      if (introPlayed || destroyed || !examRoot || !scrollEligible || !examVisible || !motionAllowed()) return;
      if (!drawExam()) return;
      introPlayed = true;
      fields.forEach(field => field.element.classList.remove('is-pending'));
      const digits = fields.flatMap((field, fieldIndex) => field.digits.map((digit, index) => ({ field, fieldIndex, digit, index })));
      if (!digits.length || !digits.every(({ digit }) => typeof digit.current.animate === 'function')) return;
      introRunning = true;
      examRoot.dataset.kkReelIntro = 'running';
      animations.forEach((_, digit) => settleDigit(digit));
      digits.forEach(({ field, fieldIndex, digit, index }) => {
        const { animation, strip } = makeReel(digit, 'kk-countdown', digit.value, 2100 + fieldIndex * 650 + index * 140, fieldIndex * 2 + index, '-');
        reels.set(digit, { animation, strip });
        animation.onfinish = () => {
          if (!introRunning) return;
          animation.cancel();
          strip.remove();
          reels.delete(digit);
          digit.element.classList.remove('is-rolling');
          digit.value = field.canonical.textContent[index];
          digit.current.textContent = digit.value;
          if (!reels.size) finishIntro();
        };
      });
    }

    function handleScroll() {
      if (destroyed || (introPlayed && scrollEligible && 'IntersectionObserver' in window)) return;
      if (Math.max(window.scrollY || 0, document.scrollingElement?.scrollTop || 0, scrollContainer?.scrollTop || 0) >= 80) scrollEligible = true;
      if (!('IntersectionObserver' in window) && examViewportTarget) {
        const wasVisible = examVisible;
        const rect = examViewportTarget.getBoundingClientRect();
        const visible = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        examVisible = rect.height > 0 && visible / rect.height >= .35;
        if (!examVisible) {
          finishIntro();
          animations.forEach((_, digit) => settleDigit(digit));
        }
        if (wasVisible !== examVisible) scheduleExam();
      }
      startIntro();
    }

    function scheduleExam(animate = false) {
      clearTimeout(timer);
      timer = undefined;
      if (destroyed || !examRoot || root.isConnected === false || document.hidden || pageHidden || !examVisible) return;
      if (drawExam(animate)) timer = setTimeout(() => scheduleExam(true), 1016 - Date.now() % 1000);
    }

    function showExam(data) {
      if (destroyed) return;
      if (!data || typeof data.target !== 'string' || !Number.isFinite(Date.parse(data.target)) || typeof data.dateLabel !== 'string' || !data.dateLabel.trim()) return;
      finishIntro();
      exam = { ...fallback, ...data, regionName: typeof data.regionName === 'string' ? data.regionName : fallback.regionName, examRegion: typeof data.examRegion === 'string' ? data.examRegion : fallback.examRegion, exact: data.exact === true };
      examRoot.querySelector('[data-kk-exam-region]').textContent = exam.examRegion;
      examRoot.querySelector('[data-kk-exam-date]').textContent = exam.dateLabel;
      const location = examRoot.querySelector('[data-kk-exam-location]');
      location.classList.toggle('is-exact', exam.exact);
      location.lastChild.textContent = examRoot.hasAttribute('data-local-preview') ? ' Vorschau · bundesweiter Mittelwert' : exam.exact ? ` Automatisch gewählt: ${exam.regionName}` : exam.regionName === 'Deutschland' ? ' Standort nicht erkannt · bundesweiter Mittelwert' : ` ${exam.regionName} · Mittelwert, da kein bestätigter Termin vorliegt`;
      drawExam();
      scheduleExam();
    }

    function sync() {
      if (!motionAllowed()) {
        finishIntro();
        animations.forEach((_, digit) => settleDigit(digit));
      }
      if (preference.matches || manuallyPaused) {
        introPlayed = true;
        drawExam();
      }
      counters.forEach(counter => {
        if (preference.matches || manuallyPaused || (counter.running && !motionAllowed())) finishCounter(counter);
        else startCounter(counter);
      });
      scheduleExam();
      startIntro();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const counter = counters.get(entry.target);
        if (counter) {
          counter.visible = entry.isIntersecting;
          if (!counter.visible && counter.running) finishCounter(counter);
          else startCounter(counter);
        } else if (entry.target === examViewportTarget) {
          examVisible = entry.isIntersecting && entry.intersectionRatio >= .35;
          if (!examVisible) {
            finishIntro();
            animations.forEach((_, digit) => settleDigit(digit));
          }
          scheduleExam();
          startIntro();
        }
      }), { threshold: [.15, .35] });
      counters.forEach(counter => observer.observe(counter.element));
      if (examViewportTarget) observer.observe(examViewportTarget);
    }

    if (examRoot) {
      root.querySelectorAll('.kk-nav__links, .kk-mobile-nav__panel').forEach(nav => {
        let link = nav.querySelector('[data-kk-exam-link]');
        if (!link) {
          link = document.createElement('a');
          link.href = '#pruefung';
          link.textContent = 'Prüfungstermin';
          link.dataset.kkExamLink = 'true';
          nav.insertBefore(link, nav.querySelector('a[href="/pages/contact"]'));
        }
        link.addEventListener('click', () => { const details = link.closest('details'); if (details) details.open = false; }, { signal: handlers.signal });
      });
      showExam(fallback);
      if (!examRoot.hasAttribute('data-local-preview')) fetch('https://lernen.kaelte-klar.de/api/gp2-exam-location', { cache: 'no-store', signal: handlers.signal })
        .then(response => { if (!response.ok) throw new Error('Standort nicht verfügbar'); return response.json(); })
        .then(showExam)
        .catch(() => {});
    }

    toggle?.addEventListener('change', () => { manuallyPaused = !toggle.checked; sync(); }, { signal: handlers.signal });
    window.addEventListener('scroll', handleScroll, { passive: true, signal: handlers.signal });
    scrollContainer?.addEventListener('scroll', handleScroll, { passive: true, signal: handlers.signal });
    window.addEventListener('storage', event => {
      if (event.key !== 'kk-background-motion' && event.key !== null) return;
      manuallyPaused = event.newValue === 'off';
      sync();
    }, { signal: handlers.signal });
    preference.addEventListener('change', sync, { signal: handlers.signal });
    document.addEventListener('visibilitychange', sync, { signal: handlers.signal });
    window.addEventListener('pagehide', () => { pageHidden = true; sync(); }, { signal: handlers.signal });
    window.addEventListener('pageshow', () => { pageHidden = false; sync(); }, { signal: handlers.signal });
    sync();
    roots.set(root, () => {
      destroyed = true;
      clearTimeout(timer);
      finishIntro();
      observer?.disconnect();
      counters.forEach(counter => { finishCounter(counter); counter.element.replaceChildren(counter.text); counter.element.classList.remove('kk-number'); });
      animations.forEach((_, digit) => settleDigit(digit));
      fields.forEach(field => {
        field.element.replaceChildren(field.canonical.textContent);
        field.element.classList.remove('kk-countdown');
        field.element.classList.remove('is-pending');
      });
      handlers.abort();
      roots.delete(root);
    });
  }

  function initializeAll() {
    document.querySelectorAll('.kk-storefront.kk-home-refined').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
